module.exports = __webpack_public_path__ + "img/icon-recordding.a60f1e78.svg";